import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10 text-black" }
const _hoisted_2 = { class: "flex justify-between flex-wrap items-center col-span-12" }
const _hoisted_3 = { class: "flex items-center gap-5" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center gap-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_List = _resolveComponent("List")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.$t("objectives.titles.lessonPlans")), 1)
      ]),
      (_ctx.role === 'TEACHER')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_Button, {
              label: _ctx.$t('labels.save'),
              disabled: _ctx.objective?.length == 0,
              class: "btn-primary p-button-sm",
              loading: _ctx.loading,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onNext()))
            }, null, 8, ["label", "disabled", "loading"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lessonPlan, (item, i) => {
      return (_openBlock(), _createBlock(_component_List, {
        key: i,
        data: item,
        error: _ctx.error[i],
        loaderList: _ctx.loaderList,
        role: _ctx.role
      }, null, 8, ["data", "error", "loaderList", "role"]))
    }), 128))
  ]))
}